export var Mode;
(function (Mode) {
    Mode["multi"] = "multi";
    Mode["range"] = "range";
    Mode["single"] = "single";
    Mode["dateRange"] = "dateRange";
})(Mode || (Mode = {}));
export var Position;
(function (Position) {
    Position["topLeft"] = "topLeft";
    Position["topRight"] = "topRight";
    Position["bottomLeft"] = "bottomLeft";
    Position["bottomRight"] = "bottomRight";
})(Position || (Position = {}));
//# sourceMappingURL=index.types.js.map